import {createSlice} from '@reduxjs/toolkit';

export const filterAjaxCallSlice = createSlice({
    name: 'filterAjaxCall',
    initialState: {
        path: '',
        isRange: false,
    },
    reducers: {
        setFilterAjaxCall: (state, action) => {
            state.path = action.payload[0];
            state.isRange = action.payload[1];
        },
    },
});

export const contentAjaxCallSlice = createSlice({
    name: 'contentAjaxCall',
    initialState: {
        path: '',
        popstate: false,
        get: true, // avoid content loading if path is the same
        counter: 0, // needed to deactivate loading spinner if path is the same
        retainShopIdFilterOnly: false,
    },
    reducers: {
        setContentAjaxCall: (state, action) => {
            state.get = state.path !== action.payload[0];
            state.path = action.payload[0];
            state.retainShopIdFilterOnly = action.payload[1];
            state.popstate = false;
            state.counter++;
        },
        setContentAjaxCallPopstate: (state, action) => {
            state.get = state.path !== action.payload;
            state.path = action.payload;
            state.popstate = true;
            state.counter++;
        },
    },
});

export const articleAjaxCallSlice = createSlice({
    name: 'articleAjaxCall',
    initialState: {
        path: '',
    },
    reducers: {
        setArticleAjaxCall: (state, action) => {
            state.path = action.payload;
        },
    },
});

export const {setFilterAjaxCall} = filterAjaxCallSlice.actions;

export const {setContentAjaxCall, setContentAjaxCallPopstate} = contentAjaxCallSlice.actions;

export const {setArticleAjaxCall} = articleAjaxCallSlice.actions;

export const selectFilterAjaxCall = (state) => state.filterAjaxCall;
export const selectContentAjaxCall = (state) => state.contentAjaxCall;
export const selectArticleAjaxCall = (state) => state.articleAjaxCall;
